import DialogHeader from './dialog-header'

export default DialogHeader
